(function () {
  'use strict';

  function money(cents) {
    var fmt = (window.themeHDN && themeHDN.settings && (themeHDN.settings.currencyFormat || themeHDN.settings.moneyFormat)) || '${{amount}}';
    function number(value, decimals, thousands, decimal) {
      value = (value / 100).toFixed(decimals);
      var parts = value.split('.');
      return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands) + (parts[1] ? decimal + parts[1] : '');
    }
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    var output = '';
    switch (key) {
      case 'amount_no_decimals': output = number(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': output = number(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': output = number(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': output = number(cents, 2, ' ', '.'); break;
      default: output = number(cents, 2, ',', '.');
    }
    return fmt.replace(match ? match[0] : '{{amount}}', output);
  }

  function productRoot(element) {
    return element ? element.closest('[data-sbl-product-main]') : null;
  }

  function getVariants(root) {
    try {
      var node = root.querySelector('[data-sbl-variants]');
      return node ? JSON.parse(node.textContent) : [];
    } catch (error) {
      return [];
    }
  }

  function getSelectedOptions(root) {
    var selected = [];
    root.querySelectorAll('[data-sbl-option-input]').forEach(function (element) {
      selected[parseInt(element.dataset.index, 10)] = element.value;
    });
    return selected;
  }

  function resetZoom(root) {
    if (!root) return;
    var wrap = root.querySelector('[data-sbl-mainimage-wrap]');
    var image = root.querySelector('[data-sbl-main-image]');
    if (wrap) wrap.classList.remove('is-zoomed');
    if (image) image.style.transformOrigin = '50% 50%';
  }

  function setMainImage(root, data) {
    if (!root) return;
    var image = root.querySelector('[data-sbl-main-image]');
    var wrap = root.querySelector('[data-sbl-mainimage-wrap]');
    if (!image || !data || !data.src) return;

    resetZoom(root);
    if (wrap) wrap.classList.add('is-switching');

    if (data.srcset) image.setAttribute('srcset', data.srcset);
    else image.removeAttribute('srcset');

    if (data.alt) image.alt = data.alt;
    if (data.width) image.setAttribute('width', data.width);
    if (data.height) image.setAttribute('height', data.height);

    var finish = function () {
      if (wrap) wrap.classList.remove('is-switching');
      image.removeEventListener('load', finish);
      image.removeEventListener('error', finish);
    };

    image.addEventListener('load', finish);
    image.addEventListener('error', finish);
    image.src = data.src;

    window.setTimeout(finish, 800);
  }

  function setActiveThumbnail(root, thumb) {
    if (!root) return;
    root.querySelectorAll('[data-sbl-thumb]').forEach(function (item) {
      var active = item === thumb;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function activateThumbnailByImageId(root, imageId) {
    if (!root || !imageId) return;
    var thumb = root.querySelector('[data-sbl-thumb][data-image-id="' + imageId + '"]');
    if (thumb) setActiveThumbnail(root, thumb);
  }

  function updateVariant(root) {
    if (!root) return;
    var options = getSelectedOptions(root);
    var list = getVariants(root);
    var variant = list.find(function (item) {
      return item.options.every(function (option, index) {
        return option === options[index];
      });
    });
    if (!variant) return;

    var id = root.querySelector('[data-sbl-variant-id]');
    var price = root.querySelector('[data-sbl-price]');
    var compare = root.querySelector('[data-sbl-compare]');
    var save = root.querySelector('[data-sbl-save]');
    var addButton = root.querySelector('[data-sbl-add]');

    if (id) id.value = variant.id;
    if (price) price.textContent = money(variant.price);

    if (compare) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compare.hidden = false;
        compare.textContent = money(variant.compare_at_price);
      } else {
        compare.hidden = true;
      }
    }

    if (save) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        save.hidden = false;
        save.textContent = (save.dataset.prefix || 'SAVE ') + money(variant.compare_at_price - variant.price);
      } else {
        save.hidden = true;
      }
    }

    if (addButton) {
      addButton.disabled = !variant.available;
      var addText = addButton.querySelector('[data-sbl-add-text]');
      if (addText) addText.textContent = variant.available ? (addButton.dataset.addText || 'Add to Cart') : (addButton.dataset.soldText || 'Sold Out');
    }

    if (variant.featured_image && variant.featured_image.src) {
      setMainImage(root, {
        src: variant.featured_image.src,
        alt: variant.featured_image.alt || '',
        width: variant.featured_image.width || '',
        height: variant.featured_image.height || ''
      });
      activateThumbnailByImageId(root, variant.featured_image.id);
    }

    if (root.dataset.updateUrl === 'true' && window.history && history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    }
  }

  function isFinePointer() {
    return window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-sbl-thumb]');
    if (thumb) {
      var root = productRoot(thumb);
      if (!root) return;
      setMainImage(root, {
        src: thumb.dataset.src,
        srcset: thumb.dataset.srcset,
        alt: thumb.dataset.alt,
        width: thumb.dataset.width,
        height: thumb.dataset.height
      });
      setActiveThumbnail(root, thumb);
      return;
    }

    var optionButton = event.target.closest('[data-sbl-option-btn]');
    if (optionButton) {
      var optionRoot = productRoot(optionButton);
      if (!optionRoot) return;
      var index = optionButton.dataset.index;
      optionRoot.querySelectorAll('[data-sbl-option-btn][data-index="' + index + '"]').forEach(function (item) {
        item.classList.remove('is-selected');
      });
      optionButton.classList.add('is-selected');
      var input = optionRoot.querySelector('[data-sbl-option-input][data-index="' + index + '"]');
      if (input) input.value = optionButton.dataset.value;
      var label = optionRoot.querySelector('[data-sbl-selected][data-index="' + index + '"]');
      if (label) label.textContent = optionButton.dataset.value;
      updateVariant(optionRoot);
      return;
    }

    var quantityButton = event.target.closest('[data-sbl-qty]');
    if (quantityButton) {
      var quantityRoot = productRoot(quantityButton);
      var quantityInput = quantityRoot && quantityRoot.querySelector('[data-sbl-qty-input]');
      if (quantityInput) {
        var value = parseInt(quantityInput.value || '1', 10) + (quantityButton.dataset.sblQty === 'plus' ? 1 : -1);
        quantityInput.value = Math.max(1, value);
      }
      return;
    }

    var tab = event.target.closest('[data-sbl-tab]');
    if (tab) {
      var tabsSection = tab.closest('[data-sbl-tabs]');
      if (!tabsSection) return;
      var key = tab.dataset.sblTab;
      tabsSection.querySelectorAll('[data-sbl-tab]').forEach(function (item) {
        item.classList.toggle('is-active', item === tab);
      });
      tabsSection.querySelectorAll('[data-sbl-panel]').forEach(function (panel) {
        panel.classList.toggle('is-active', panel.dataset.sblPanel === key);
      });
      return;
    }

    var zoomWrap = event.target.closest('[data-sbl-mainimage-wrap]');
    if (zoomWrap && zoomWrap.dataset.zoomEnabled === 'true' && !isFinePointer()) {
      zoomWrap.classList.toggle('is-zoomed');
      var zoomImage = zoomWrap.querySelector('[data-sbl-main-image]');
      if (zoomImage) zoomImage.style.transformOrigin = '50% 50%';
    }
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-sbl-option-input]')) return;
    var root = productRoot(event.target);
    if (!root) return;
    var label = root.querySelector('[data-sbl-selected][data-index="' + event.target.dataset.index + '"]');
    if (label) label.textContent = event.target.value;
    updateVariant(root);
  });

  document.addEventListener('pointermove', function (event) {
    if (!isFinePointer()) return;
    var wrap = event.target.closest('[data-sbl-mainimage-wrap]');
    if (!wrap || wrap.dataset.zoomEnabled !== 'true') return;
    var image = wrap.querySelector('[data-sbl-main-image]');
    if (!image) return;
    var rect = wrap.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    var x = Math.max(0, Math.min(100, ((event.clientX - rect.left) / rect.width) * 100));
    var y = Math.max(0, Math.min(100, ((event.clientY - rect.top) / rect.height) * 100));
    image.style.transformOrigin = x.toFixed(2) + '% ' + y.toFixed(2) + '%';
  });

  document.addEventListener('pointerout', function (event) {
    var wrap = event.target.closest && event.target.closest('[data-sbl-mainimage-wrap]');
    if (!wrap || wrap.contains(event.relatedTarget)) return;
    var image = wrap.querySelector('[data-sbl-main-image]');
    if (image) image.style.transformOrigin = '50% 50%';
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      document.querySelectorAll('[data-sbl-mainimage-wrap].is-zoomed').forEach(function (wrap) {
        wrap.classList.remove('is-zoomed');
        var image = wrap.querySelector('[data-sbl-main-image]');
        if (image) image.style.transformOrigin = '50% 50%';
      });
      return;
    }

    if ((event.key === 'Enter' || event.key === ' ') && event.target.matches('[data-sbl-mainimage-wrap][data-zoom-enabled="true"]')) {
      event.preventDefault();
      event.target.classList.toggle('is-zoomed');
    }
  });
})();
